module.exports = __webpack_public_path__ + "img/news0.e98f82a4.png";